import {mobileVhFix} from './utils/mobile-vh-fix';
import {initAccordion} from './modules/accordion/init-accordion';
import {initCustomSelect} from './modules/custom-select/init-custom-select';
import {initHeader} from './modules/header/init-header';
import {initModals} from './modules/modal/init-modals';
import {initPhoneMask} from './modules/init-phone-mask';
import {initTabs} from './modules/tabs/init-tabs';
import {initValidation} from './modules/wordpress/validation/init-validation';
import {initSmoothScroll} from './modules/init-smooth-scroll';
import {initUsageScroll} from './modules/init-usage-scroll';
import {initVideo} from './modules/init-video';
import {initReviewsSlider} from './modules/sliders/init-reviews-slider';
import {initInstructionSlider} from './modules/sliders/init-instruction-slider';
import {initMoreless} from './modules/moreless/init-moreless';
import {initQuantity} from './modules/init-quantity';
import {initOrderPrice} from './modules/init-order-price';
import {cookieBannerHandler} from './modules/cookie-banner-handler';
import {initAddToCart} from './modules/init-add-to-cart';
import {initCartQuantity} from './modules/init-cart-quantity';
import {initCartRemove} from './modules/init-cart-remove';
import {initCartSummary} from './modules/init-cart-summary';
import {initCheckoutSummary} from './modules/init-checkout-summary';
import {initCheckoutErrors} from './modules/init-checkout-errors';
import {initCityAutocomplete} from './modules/init-city-autocomplete';
import {initOrderSuccessModal} from './modules/init-order-success-modal';

const ENABLE_SMOOTH_SCROLL = true;

window.addEventListener('DOMContentLoaded', () => {
  // Utils
  // ---------------------------------

  mobileVhFix();
  const lenis = ENABLE_SMOOTH_SCROLL ? initSmoothScroll() : null;

  // Modules
  // ---------------------------------

  const tabs = initTabs();
  initHeader();
  initModals();
  initAccordion();
  initCustomSelect();
  initValidation();
  initPhoneMask();
  initVideo();
  initMoreless();
  initQuantity();
  initOrderPrice();
  initUsageScroll(lenis, tabs);
  cookieBannerHandler();
  initAddToCart();
  initCartQuantity();
  initCartRemove();
  initCartSummary();
  initCheckoutSummary();
  initCheckoutErrors();
  initCityAutocomplete();
  initOrderSuccessModal();

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    initReviewsSlider();
    initInstructionSlider();
  });
});

// ---------------------------------

// ❗❗❗ обязательно установите плагины eslint, stylelint, editorconfig в редактор кода.

// привязывайте js не на классы, а на дата атрибуты (data-validate)

// вместо модификаторов .block--active используем утилитарные классы
// .is-active || .is-open || .is-invalid и прочие (обязателен нейминг в два слова)
// .select.select--opened ❌ ---> [data-select].is-open ✅

// выносим все в дата атрибуты
// url до иконок пинов карты, настройки автопрокрутки слайдера, url к json и т.д.

// для адаптивного JS используейтся matchMedia и addListener
// const breakpoint = window.matchMedia(`(min-width:1024px)`);
// const breakpointChecker = () => {
//   if (breakpoint.matches) {
//   } else {
//   }
// };
// breakpoint.addListener(breakpointChecker);
// breakpointChecker();

// используйте .closest(el)
